/**
 * Check buttons list component script
 */
export const GalleryUploader = (function () {
  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };


  var init = function () {

    $('.append-gallery-results').each(function(){
      var key = $(this).attr('key');
      getGallery(key);
    });
  };

  var getGallery = function (key) {
    
    var offset = parseInt($(".append-gallery-results[key="+key+"]").attr('data-attr-offset'));
    var limit = parseInt($(".append-gallery-results[key="+key+"]").attr('data-attr-limit'));


    var fetchImages = $('.gallery-input[data-attr-key="'+key+'"]').val().split(',');
    var fetchImagesQs = '';
    $(fetchImages).each(function(idx, val){
      if(parseInt(val)){
        fetchImagesQs += val+',';
      }
    });
    fetchImagesQs = fetchImagesQs.substring(0, fetchImagesQs.length - 1);
    
    if(!fetchImagesQs){return false;}

    $.get({
      url: MaMFormHandler.getBaseUrl()+"/get-value?type=gallery&limit="+limit+"&offset="+offset+"&ids="+fetchImagesQs,
      contentType: false,
      processData: false,
      headers: csrfHeaders(),
      success: function (res) {
        var images = res.images.my_images;
        var inputs = [];
        $.each(images, function (idx, element) {
          $(".append-gallery-results[key="+key+"]").append(element.html);
          
          inputs.push(idx);
        });

        var existingInputs = $('.gallery-input[data-attr-key="'+key+'"]').val();
        $('.gallery-input[data-attr-key="'+key+'"]').val(existingInputs+','+inputs.join(','));

         
        offset = offset + limit;
        $(".append-gallery-results[key="+key+"]").attr('data-attr-offset', offset);
        
        initControls(key);
      },
      complete: function (res) {},
    });
    return false;
  };

  var initControls = function (key) {

    $('.gallery-load-more').off('click').on('click', function(){
      getGallery(key);
      return false;
    });

    $(".delete-gallery-confirm").on("click", function () {
      var id = $(this).attr("data-attr-id");
      
      var key = $(this).attr("data-attr-key");

      $.post({
        url: MaMFormHandler.getBaseUrl()+"/unset-value",
        data: {
          id: id,
        },
        headers: csrfHeaders(),
        success: function (res) {
          console.log(res);
          $("#deleteImageModal-"+key).modal("hide");
          $(".profile-pic-has-image[data-attr-id=" + id + "]").remove();
        },
        dataType: "json",
      });
    });

    $(".profile-pic-remove")
      .off("click")
      .on("click", function () {
        var key = $(this).attr("key");
        var id = $(this).closest(".profile-pic-has-image").attr("data-attr-id");

        $(".delete-gallery-confirm").attr("data-attr-id", id);

        $("#deleteImageModal-"+key).modal("show");
        return false;
      });

    $(".gallery-image-click")
      .off("click")
      .on("click", function () {
        var id = $(this).closest(".profile-pic-has-image").attr("data-attr-id");
        var key = $(this).closest('.append-gallery-results').attr('key');

        var galleryModal = $("#galleryDescriptionModal-"+key);
        $(galleryModal).modal("show");

        $(galleryModal).find(".modal-save-control").attr("data-attr-id", id);
        $(galleryModal).find(".gallery-modal-delete").attr("data-attr-id", id);

        //clear out existing modal contents

        $("#gallery-modal-description-"+key)
        .val('');

        $("#gallery-modal-src-"+key)
          .css("background-image", "none");

        $("#gallery-modal-image-"+key)
          .val('');

        $("#gallery-modal-filename-"+key)
          .val('');

        $.get({
          url: MaMFormHandler.getBaseUrl()+"/get-value?type=gallery-image&id=" + id+"&key="+key,
          contentType: false,
          processData: false,
          headers: csrfHeaders(),
          success: function (res) {
            $.each(res.images, function (idx, img) {
              $("#gallery-modal-description-"+key)
                .off("blur")
                .val(img.description);
              $("#gallery-modal-src-"+key)
                .css("background-image", "url(" + img.file + ")");
              $("#gallery-modal-image-"+key)
                .val(img.original);
              $("#gallery-modal-filename-"+key)
                .val(img.file_name);
            });

            
          },
          complete: function (res) {},
        });
      });

    $(".modal-save-control")
      .off("click")
      .on("click", function () {
        
        var galleryModal = $("#galleryDescriptionModal");
        var id = $(this).attr("data-attr-id");
        var key = $(this).attr("data-attr-key");

        var payload = {
          description: $("#gallery-modal-description-"+key).val(),
          //file: $("#gallery-modal-image").val()
          file_name: $("#gallery-modal-filename-"+key).val() 
        };

        $.post({
          url: MaMFormHandler.getBaseUrl()+"/set-value?type=gallery-image&id=" + id,
          dataType: "json",
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            console.log(res);
            $("#galleryDescriptionModal-"+key).modal("hide");

            //replace the description
            $('.append-gallery-results[key="'+key+'"] .profile-pic-has-image[data-attr-id="'+id+'"]')
                .find('.description').html(payload.description);

            

          },
          complete: function (res) {},
        });
      });

      
      $(".gallery-modal-delete")
      .off("click")
      .on("click", function () {
        var galleryModal = $("#galleryDescriptionModal");
        var id = $(this).attr("data-attr-id");
        var key = $(this).attr("data-attr-key");
        var payload = {
          id: id
        };

        if(!confirm("Are you sure?")){
          return false;
        }

        $.post({
          url: MaMFormHandler.getBaseUrl()+"/set-value?type=gallery-image-delete&id=" + id,
          dataType: "json",
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            $("#galleryDescriptionModal-"+key).modal("hide");
            $('.profile-pic-col[data-attr-id="'+id+'"]').remove();

            //remove the image id from the array to be posted back to the component
            var existingInputs = $('.gallery-input[data-attr-key="'+key+'"]').val();
            $('.gallery-input[data-attr-key="'+key+'"]').val(existingInputs.replaceAll(id, ''));
            $('.gallery-input.bsave').trigger('blur');

          },
          complete: function (res) {},
        });
        
      });
  };

  return {
    init: init,
    initControls: initControls
  };
})();
